import { render, staticRenderFns } from "./yuanzhuanting.vue?vue&type=template&id=6eb78e67&"
import script from "./yuanzhuanting.vue?vue&type=script&lang=js&"
export * from "./yuanzhuanting.vue?vue&type=script&lang=js&"
import style0 from "./yuanzhuanting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports